module.exports = __webpack_public_path__ + "static/scientist6-67b1cdac82a93a605cd58aad9369a613.png";